import { useTranslation } from 'react-i18next';
import BannerContent from './BannerContent';
import trophy from '@/assets/images/trophy.svg';
import {
  GiveawayHomepageDtoRead,
  LeaderboardResponseDto,
} from '@/store/services/MidleNestApi.service';

interface PartnershipBannerProps {
  leftReward?: GiveawayHomepageDtoRead | null;
  rightReward?: GiveawayHomepageDtoRead | null;
  userLeaderBoard?: LeaderboardResponseDto | null;
  guildLeaderBoard?: LeaderboardResponseDto | null;
}

export default function GiveawayWinners({
  leftReward,
  rightReward,
  userLeaderBoard,
  guildLeaderBoard,
}: PartnershipBannerProps) {
  const { t } = useTranslation();

  return (
    <div className='relative h-max xl:mt-16 p-3 sm:p-14 overflow-hidden bg-white dark:bg-[#242424] dark:border dark:border-[#FFDA68]/30 flex flex-col items-center text-[#111827] dark:text-white rounded-3xl shadow-md hover:drop-shadow-md transition-all duration-300 ease-in-out '>
      {/* <div className='hidden xl:block absolute left-0 -top-14'> */}
      {/*   <img src={trophy} width='100' alt={t('trophy')} className='' /> */}
      {/* </div> */}
      <div
        style={{
          background:
            'radial-gradient(40.25% 40.25% at 14.69% 80.69%, #40D1FF 27.08%, #3E51FF 100%)',
        }}
        className='absolute opacity-80 w-[748px] aspect-square top-[-415px] right-[-415px] rounded-full blur-xl'
      />
      <div
        style={{
          background: 'radial-gradient(76.75% 76.75% at 67.45% 25.26%, #FFDA68 0%, #FFA901 67.19%)',
        }}
        className='absolute opacity-80 w-[834px] aspect-square bottom-[-482px] left-[-580px] rotate-[25deg] rounded-full blur-xl'
      />

      <h3 className='text-base font-bold sm:text-3xl'>{t('Giveaways')}</h3>
      <p className='mt-2 text-xs sm:text-xl'>
        {t('Through weekly and monthly giveaways, you may win daily-reward.')}
      </p>

      <div className='mt-6 sm:mt-8 md:mt-14 w-full grid lg:grid-cols-2 gap-14'>
        <BannerContent
          title={t('Weekly Giveaway Winners')}
          giveawayEntities={leftReward?.winners}
          totalReward={leftReward?.totalReward}
          rewardToken={leftReward?.rewardToken}
          className=''
        />
        <BannerContent
          title={t('Monthly Giveaway Winners')}
          giveawayEntities={rightReward?.winners}
          totalReward={rightReward?.totalReward}
          rewardToken={rightReward?.rewardToken}
          className=''
        />
      </div>

      <h3 className='mt-14 text-base font-bold sm:text-3xl'>{t('Leaderboard')}</h3>
      <p className='mt-2 text-xs sm:text-xl'>
        {t('Prizes are awarded to the top 5 in the Clan and the top 10 in the Players.')}
      </p>

      <div className='mt-6 sm:mt-8 md:mt-14 w-full grid lg:grid-cols-2 gap-14'>
        <BannerContent
          title={t('Players Leaderboard Winners')}
          leaderBoardEntities={userLeaderBoard?.list}
        />
        <BannerContent
          title={t('Clans Leaderboard Winners')}
          leaderBoardEntities={guildLeaderBoard?.list}
        />
      </div>
    </div>
  );
}
